import React, { Component } from 'react';
import { LenderRow } from '../components/LenderRow.tsx';
import { ILead, ILeadCalculationResult } from '../helpers/Models.tsx';
import axios from 'axios';
import { PreviousButton } from '../components/PreviousButton.tsx';

interface IProps {
    gtmEvent(): void;
    lead: ILead;
    nextStep(r?:string): void;
    prevStep(): void;
    setLenderResult(r: ILeadCalculationResult): void;
}

interface IState {
    checking: boolean;
}

export class CheckingLenders extends Component<IProps, IState> {

    constructor(props:IProps) {
        super(props);
        this.state = {checking: false};
    }

    componentDidMount(): void {
        this.props.gtmEvent();

        if (!this.state.checking) {
            this.lenderCheck();
        }
    }

    lenderCheck() {
        axios.post("/lead/CalculateLeadRepayment", this.props.lead)
            .then((response) => {
                var lenderResult: ILeadCalculationResult = response.data;
                this.props.setLenderResult(lenderResult);
                
                // give the lender result first change to change the state
                setTimeout(() => this.props.nextStep(lenderResult.response), 200);
            })
            .catch((error) => {
                //alert('submit error: ' + error.message);
            });
        this.setState({checking: true});
    }

    render() {
        return (
            <header className={`App-header`} >
                <h1 className='l'><span className='doddltext'>One moment,</span> we're<br />checking all major lenders...</h1>
                <p>{`so that you don't have to ;-)`}</p>
                <div className='wrapper'>
                    <div className='row'>
                        {/* <img src='https://doddl.ie/wp-content/uploads/2022/12/Spinner-1s-200px.gif' /> */}
                        <div className='loading-spinner'/>
                    </div>
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>

                </div>
            </header>
        );
    }
}
